import { AppThunk } from 'redux/store'
import * as safeApi from 'api'
import { updatePassTiersStatus } from 'redux/slices/liveShow'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { updateRemainingPassesAction } from 'redux/slices/liveShow/thunks'
import { showPassListReceived, userPassesReceived, purchasePassReceieved } from 'redux/slices/passes'
import { handleApiError } from 'redux/slices/error'
import { showErrorBanner } from 'redux/slices/messagingBanner'
import { provideAccess } from 'redux/slices/paywall'
import { onUserPurchasedPassMsg } from 'redux/slices/messagingBanner/thunks'

import * as Result from 'data/ApiResult'

export const createPass = createAsyncThunk(
    'passes/createPass',
    async (
        { showId, fullName, email }: { showId: string; fullName: string; email: string },
        { dispatch, rejectWithValue }: any,
    ) => {
        const result = await safeApi.postPass({ showId, fullName, email })

        return Result.cata(result, {
            Success: pass => {
                dispatch(purchasePassReceieved(pass))
                dispatch(provideAccess())
                dispatch(onUserPurchasedPassMsg())
                window.heap.track('Free Pass Purchase Success')
            },
            HttpError: () => {
                return rejectWithValue({ error: 'We found some errors. Please try again' })
            },
            _: () => {},
        })
    },
)

export const retrieveUserShowPasses = showId => async dispatch => {
    const result = await safeApi.getAllPasses({ params: { showId } })

    if (Result.isFailure(result)) {
        dispatch(showPassListReceived([]))
        dispatch(
            showErrorBanner({
                message: "We're having trouble fetching your previously purchased passes. Please refresh the page",
            }),
        )
        return
    }

    const { passes, remainingPasses, remainingForPassTiers } = result.data

    dispatch(updatePassTiersStatus(remainingForPassTiers))
    dispatch(showPassListReceived(passes))
    dispatch(updateRemainingPassesAction(remainingPasses))
}

export const retrieveAllUserPasses = (): AppThunk => async dispatch => {
    const result = await safeApi.getAllPasses()

    if (Result.isSuccess(result)) {
        dispatch(userPassesReceived(result.data.passes))
    } else {
        dispatch(handleApiError(result))
    }
}
